<template>
  <div class="cover-group">
    <ul class="cover-sites" v-for="(group, index) in allCoverSizes" :key="index">
      <li
        class="site"
        v-for="(size, index) in group.sizes"
        :key="index"
        @click="selectSize(size)"
        :class="{ on: selectedSizeIds.includes(size.id) }"
      >
        <i :class="['iconfont', { 'icon-gouxuan': selectedSizeIds.includes(size.id) }]"></i>{{ size.sizeName }}
        {{ size.width }}*{{ size.height }}
      </li>
    </ul>
  </div>
</template>
<script>
import { genCoverDataBySize } from "@/pages/cover/js/cover-feature";
import { mapMutations, mapState } from "vuex";
export default {
  name: "coverSize",
  data() {
    return {};
  },
  computed: {
    ...mapState("cover", ["coverDataList", "coverData"]),
    ...mapState("ai", ["allCoverSizes"]),
    // 选中的站点
    selectedSizeIds() {
      return this.coverDataList.map(cover => parseInt(cover.sizeId));
    },
  },
  methods: {
    ...mapMutations("cover", ["updateCoverDataList", "deleteCoverData"]),
    // 选中一个业务线
    async selectSize(size) {
      if (!this.selectedSizeIds.includes(parseInt(size.id))) {
        const cover = genCoverDataBySize(size);
        cover.fontStyles.forEach((item, index) => {
          const fontStyle = this.coverData.fontStyles[index] || {};
          item.isLabelStyle = fontStyle.isLabelStyle;
          item.labelStyle = fontStyle.labelStyle;
          // 如果是默认尺寸，文案则和this.coverData的文案一致
          if (size.id === parseInt(process.env.VUE_APP_COVER_SIZE_ID)) {
            item.text = fontStyle.text;
          }
        });
        this.updateCoverDataList({
          list: [
            {
              ...this.coverData,
              ...cover,
            },
          ],
        });
      } else {
        const index = this.coverDataList.findIndex(cover => parseInt(cover.sizeId) === parseInt(size.id));
        index > -1 && this.deleteCoverData(index);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cover-sites {
  width: auto;
  .site {
    display: block;
    margin-bottom: 10px;
    position: relative;
    padding: 0 0 0 46px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid rgba(148, 131, 255, 0.3);
    background: #242931;
    line-height: 38px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    .iconfont {
      position: absolute;
      left: 16px;
      width: 20px;
      height: 20px;
      font-size: 8px;
      color: #242931;
      top: 50%;
      transform: translate(0, -50%);
      border: 1px solid #6d7278;
      border-radius: 100%;
      line-height: 22px;
      &:before {
        position: absolute;
        top: -1px;
        left: 5px;
        transform: scale(0.9);
      }
    }
    &.on,
    &:hover {
      border-color: #8569d9;
      background: linear-gradient(295deg, rgba(122, 85, 232, 0.2) -2.91%, rgba(23, 143, 255, 0.2) 89.83%);
    }
    &.on {
      .iconfont {
        background: linear-gradient(295deg, #8569d9 0%, #4da9ff 100%);
        border: none;
      }
    }
  }
}
</style>
